import { useEffect, useState } from 'react';
import { queueSize, subscribeToQueue } from '../lib/sync.js';

/**
 * Indicador de rede e de fila (spec 10.6).
 *
 * "Persistente e discreto": aparece so quando ha algo a dizer — sem rede ou com
 * escrita pendente. Um badge permanente de "online" ocuparia espaco para
 * confirmar o estado normal, que e o unico que ninguem precisa conferir.
 *
 * Os dois estados sao separados de proposito. "Sem conexão" e a causa;
 * "3 alterações pendentes" e a consequencia, e ela sobrevive a volta da rede
 * enquanto a fila drena.
 */
export function SyncIndicator() {
  const [pendentes, setPendentes] = useState(0);
  const [online, setOnline] = useState(
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    let vivo = true;

    const atualizar = () => {
      void queueSize().then((total) => {
        if (vivo) setPendentes(total);
      });
    };

    atualizar();
    const desinscrever = subscribeToQueue(atualizar);

    const aoConectar = () => setOnline(true);
    const aoDesconectar = () => setOnline(false);
    window.addEventListener('online', aoConectar);
    window.addEventListener('offline', aoDesconectar);

    return () => {
      vivo = false;
      desinscrever();
      window.removeEventListener('online', aoConectar);
      window.removeEventListener('offline', aoDesconectar);
    };
  }, []);

  if (online && pendentes === 0) return null;

  const plural = pendentes === 1 ? 'alteração pendente' : 'alterações pendentes';
  const texto = online
    ? `${pendentes} ${plural}`
    : pendentes > 0
      ? `Sem conexão · ${pendentes} ${plural}`
      : 'Sem conexão';

  return (
    <div
      // `polite` e nao `assertive`: perder a rede nao deve interromper a leitura
      // em curso, mas precisa ser anunciado.
      role="status"
      aria-live="polite"
      className="flex items-center gap-2 rounded-sm bg-surface-2 px-3 py-1 text-sm text-text-mut"
    >
      {/*
        Ponto sem cor semantica forte: ficar sem rede nao e erro do usuario, e
        vermelho esta reservado a vencido/Q1 (spec 7.1).
      */}
      <span
        aria-hidden="true"
        className={['h-2 w-2 shrink-0 rounded-full', online ? 'bg-brand-blue' : 'bg-text-mut'].join(
          ' ',
        )}
      />
      {texto}
    </div>
  );
}
